import React, { useEffect } from 'react';
import './HomeSlider.css';
import { useNavigate } from 'react-router-dom';
import { Box, Skeleton } from '@mui/material';
import { PUBLIC_CMS_URL, IMAGE_DIR_PATH } from '../../../APIs/endpoint';
import Slider from 'react-slick';

const HomeSliderComponent = ({ homeSliderData, isLoader }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const preloadImage = new Image();
    if (homeSliderData?.[0]?.banner_image) {
      preloadImage.src = `${PUBLIC_CMS_URL}${IMAGE_DIR_PATH.HOME_BANNER_SLIDER_PATH}${homeSliderData[0].banner_image}.webp`;
    }

    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'style';
    link.href = './HomeSlider.css';
    link.onload = () => (link.rel = 'stylesheet');
    document.head.appendChild(link);
  }, [homeSliderData]);

  const settings = {
    dots: true,
    fade: false,
    infinite: true,
    arrows: true,
    autoplay: !isLoader,
    autoplaySpeed: 5000,
    pauseOnHover: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  return (
    <Box
      className="slider-container"
      sx={{ maxHeight: { xs: 252, sm: 320, md: 470, lg: 639 }, content: '""' }}>
      {isLoader ? (
        <Skeleton
          variant="rectangular"
          sx={{
            width: { xs: '100%', sm: '100%', md: 1000, lg: 1399, xl: 1900 },
            height: { xs: 252, sm: 320, md: 470, lg: 639 }
          }}
        />
      ) : (
        <Slider className="parent_component" {...settings}>
          {homeSliderData
            ?.sort((a, b) => a.bannerslider_sequence_no - b.bannerslider_sequence_no)
            .map((item, i) => (
              <Box key={i} className="img_section">
                <img
                  loading={i === 0 ? 'eager' : 'lazy'}
                  srcSet={`
                  ${PUBLIC_CMS_URL}${IMAGE_DIR_PATH.HOME_BANNER_SLIDER_PATH}${item.banner_image}?w=300 300w,
                  ${PUBLIC_CMS_URL}${IMAGE_DIR_PATH.HOME_BANNER_SLIDER_PATH}${item.banner_image}?w=768 768w,
                  ${PUBLIC_CMS_URL}${IMAGE_DIR_PATH.HOME_BANNER_SLIDER_PATH}${item.banner_image}?w=1024 1024w
                `}
                  sizes="(max-width: 600px) 300px, (max-width: 1024px) 768px, 1024px"
                  src={`${PUBLIC_CMS_URL}${IMAGE_DIR_PATH.HOME_BANNER_SLIDER_PATH}${item.banner_image}`}
                  alt="Slider_img"
                  onClick={() => navigate('/explore')}
                  style={{ cursor: 'pointer' }}
                />
                {/* <div className="banner-overlay">
                  <div className="set-style">
                    <h2 className="banner-title">{item.banner_title}</h2>
                    <p className="banner-description">{item.banner_description}</p>
                  </div>
                </div> */}
              </Box>
            ))}
        </Slider>
      )}
    </Box>
  );
};

export default React.memo(HomeSliderComponent);
